import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
import FileUpload from "@mui/icons-material/FileUpload";
import { Box, Button, Typography } from "@mui/material";
import { HeaderBar } from "../../generic/components/header-bar";

import type { FC } from "react";

interface ContentLibraryHeaderProps {
  onUpload: () => void;
  isSelectionMode: boolean;
  selectedAssetCount: number;
  onToggleSelectionMode: () => void;
  onClearSelection: () => void;
}

export const ContentLibraryHeader: FC<ContentLibraryHeaderProps> = ({
  onUpload,
  isSelectionMode,
  selectedAssetCount,
  onToggleSelectionMode,
  onClearSelection,
}) => (
  <HeaderBar navBurger>
    <Typography variant="body1" fontWeight={700} fontSize={16}>
      Content Library
    </Typography>
    <Box>
      <Button
        onClick={onToggleSelectionMode}
        variant={isSelectionMode ? "contained" : "outlined"}
        color="primary"
        data-analytics-id="content-library-toggle-selection-mode"
        sx={{ mr: 2 }}
      >
        {isSelectionMode ? "Done selecting" : "Select assets"}
      </Button>
      {isSelectionMode && selectedAssetCount > 0 && (
        <Button
          onClick={onClearSelection}
          variant="text"
          color="inherit"
          data-analytics-id="content-library-clear-selection"
          sx={{ mr: 2 }}
        >
          Clear ({selectedAssetCount})
        </Button>
      )}
      <Button
        onClick={onUpload}
        variant="outlined"
        color="primary"
        data-analytics-id="content-library-upload-file"
        startIcon={<FileUpload />}
        sx={{ mr: 2 }}
      >
        Upload file
      </Button>
      <Button
        variant="contained"
        color="primary"
        href="/"
        data-analytics-id="content-library-create-content-cta"
        startIcon={<AutoFixHigh />}
      >
        Create Content
      </Button>
    </Box>
  </HeaderBar>
);
